module.exports = __webpack_public_path__ + "media/damages/car-fl-42961aad.png";